/**
 * Common JS controller.
 *
 * Use this class to run scripts globally and to provide
 * modular helper functions for other scripts classes.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

// Require fastclick for a faster mobile UX.
const FastClick = require( 'fastclick' );

const WebFont = require( 'webfontloader' );

/**
 * Class Common
 */
class Common {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // The accessible outline style container.
        this.focusStyleContainer = document.getElementById( 'accessible-outline' );
        this.objectfitContainers = $( '.js-object-fit-image-container' );

        // Search form desktop for autocomplete.
        this.searchFormDesktop  = $( Common.$( '#nav--desktop__search__form' ) );
        this.searchFormInput    = $( Common.$( '[id^="nav--desktop__search__form__input"]' ) );

        // Libre Form.
        this.libreForm = $( '.libre-form' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Add the outline nullifying style to the
        // container in the document head when using the mouse.
        document.body.addEventListener( 'mousedown', e => {
            if ( this.focusStyleContainer ) {
                this.focusStyleContainer.innerHTML = '*:focus{outline:none!important}';
            }
        });

        // Remove the outline nullifying style from the
        // container in the document head when using the keyboard.
        document.body.addEventListener( 'keydown', e => {
            if ( this.focusStyleContainer ) {
                this.focusStyleContainer.innerHTML = '';
            }
        });

        // Save form data on submit for future use.
        if ( this.libreForm ) {
            this.libreForm.on( 'submit', e => {
                this.form = e.target;
                this.formBtn = $( this.form ).find( 'button' );

                this.formBtn.html( '<i class="fas fa-spin fa-spinner-third"></i>' );
                this.formBtn.attr( 'disabled', true );
                this.formBtnText = this.formBtn.html();
            });
        }

        // Libre Form is showing 'thank you' message and hiding form after success,
        // so here we replace that message with form to make it look like that user is redirected directly to 'thank you' page.
        if ( window.wplf ) {
            window.wplf.successCallbacks.push( res => {
                $( '.wplf-success' ).before( $( this.form ) );
                $( '.wplf-success' ).remove();

                window.location.href = '/kiitos?lomake=' + res.slug;
            });

            window.wplf.errorCallbacks.push( res => {
                this.formBtn.html( 'Lähetä' );
                this.formBtn.attr( 'disabled', false );
                $( '.wplf-success' ).remove();
            });
        }

        // Gravity Forms success message autoscroll. Built-in feature was not
        // scrolling to the correct position, so we're replacing it with this.
        $( document ).on( 'gform_confirmation_loaded', ( e, formID ) => {
            const scrollElement = document.scrollingElement || document.documentElement || document.body;
            const $confirmation = $( '#gform_confirmation_wrapper_' + formID )
                .attr( 'tabindex', -1 )
                .trigger( 'focus' );
            const $section = $confirmation.parents( 'section:first' );
            if ( $section.length ) {
                scrollElement.scrollTop = $section.offset().top;
            }
        });

        // Init modaals.
        $( '.modaal-button' ).modaal();
    }

    /**
     * Fallback for object fit.
     */
    objectFitFallback() {

        // IE and Edge CSS Object fit fallback javascript
        if ( ! Modernizr.objectfit ) {

            // Loop through object fit containers.
            this.objectfitContainers.each( function() {

                // Variables
                let $container  = $( this );
                let imgUrl      = $container.find( 'img' ).prop( 'src' );

                if ( imgUrl ) {
                    $container
                    .css( 'backgroundImage', 'url(' + imgUrl + ')' )
                    .addClass( 'compat-object-fit' );
                }
            });
        } // End if().
    }

    /**
     * Handle file download form submission.
     */
    handleFileForms() {

        // Go through all modaal containers.
        $( '.file-modaal' ).each( ( i, el ) => {

            const modal = $( el );
            const form  = modal.find( '.file-modaal__form' );

            // Prevent form submission, this is handled with AJAX.
            form.submit( function( e ) {

                e.preventDefault();

                const uniqid     = form.attr( 'data-id' );
                const listID     = form.find( '.joinID' ).val();
                const firstname  = form.find( '.file-firstname' ).val();
                const lastname   = form.find( '.file-lastname' ).val();
                const email      = form.find( '.file-email' ).val();
                const errorMsg   = $( '#js-file-error-' + uniqid );
                const successMsg = $( '#js-file-success-' + uniqid );

                // Hide messages.
                errorMsg.addClass( 'hidden' );
                successMsg.addClass( 'hidden' );

                const postData = {
                    email: email,
                    etunimi: firstname,
                    sukunimi: lastname,
                    join: listID
                };

                $.ajax({
                    method: 'POST',
                    url: ajaxurl,
                    data: {
                        action: 'salesforce_marketing_cloud_request',
                        data: postData,
                        endpoint: 'https://info.pohjantahti.fi/l/1048172/2023-11-27/b8v',
                        nonce: nonce
                    },
                    success: function() {

                        // Endpoint does not return any reasonable response.
                        // We have to just trust that submission is ok when status is ok.
                        // Show success message.
                        successMsg.removeClass( 'hidden' );

                        // Inform screen readers about success.(Use same message as newsletter form).
                        wp.a11y.speak( LocalData.newsletter_success, 'polite' );
                    },
                    error: function() {

                        // Show error message.
                        errorMsg.removeClass( 'hidden' );

                        // Inform screen readers about error. (Use same message as newsletter form).
                        wp.a11y.speak( LocalData.newsletter_error, 'polite' );
                    }
                });
            });
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.objectFitFallback();
        FastClick.attach( document.body );
        this.searchAutocomplete();
        this.addFooterDate();
        this.webFontLoader();
        this.handleFileForms();
    }

    /**
     * Toggles the state of an elements aria-hidden attribute. If the element does not have an aria-hidden attribute,
     * one will be created and set to false.
     *
     * @param {object} elements The nodelist containing the elements
     * @return {void}
     */
    static toggleAriaHidden( element ) {
        const ariaExpandedState = element.getAttribute( 'aria-hidden' ) === 'false' ? true : false;
        element.setAttribute( 'aria-hidden', ariaExpandedState );
    }

    /**
     * Removes classname from each element in a nodelist or array of elements.
     *
     * @param {object} elements  The nodelist containing the elements
     * @param {string} className The classlist to remove
     * @return {void}
     */
    static removeClassFromAll( elements, className ) {

        // Return early if missing required attributes.
        if ( ! elements || ! className  ) {
            return;
        }

        Array.from( elements ).forEach( element => {
            element.classList.remove( className );
        });
    }

    /**
     * Set attribute on each element in a nodelist or array of elements.
     *
     * @param {object} elements  The nodelist or array containing the elements
     * @param {string} attribute The attribut to change
     * @param {string} value     The value of the attribute
     * @return {void}
     */
    static setAttrOnAll( elements, attribute, value ) {

        // // Return early if missing required attributes.
        if ( ! elements || ! attribute || ! value  ) {
            return;
        }

        Array.from( elements ).forEach( element => {
            element.setAttribute( attribute, value );
        });
    }

    /**
     * Get all the siblings of an element. Optionally specify a classname to only get the elements with said class.
     *
     * @param {object} element   The element whose sibilings to find.
     * @param {string} classname Optional classname that siblings must match.
     * @return {object}    Returns empty array if no matches are found; otherwise, it returns all matching elements.
     */
    static siblings( element, classname ) {

        // Return empty arry if missing required attributes
         if ( ! element ) {
            return [];
        }

        return Array.prototype.filter.call( element.parentNode.children,
            function( child ) {
                if ( classname ) {
                    if ( ! child.classList.contains( classname ) ) {
                        return false;
                    }
                }
                return child !== element;
            }
        );
    }

    /**
     * Select a list of matching child elements from an array of elements.
     *
     * @param  {object} elements A nodelist. Use each item in nodelist as context when finding the children.
     * @param  {string} selector The query selector string.
     * @return {object]}   Returns empty array if no matches are found; otherwise, it returns all matching elements.
     */
    static childrenFromEach( elements, selector ) {

        // Return empty array if missing required attributes or elements empty
        if ( ! elements || ! selector || ! elements.length > 0 ) {
            return [];
        }

        const arrayOfNodes = Array.prototype.map.call( elements,
            function( element ) {

                // Get all matching elements.
                const matchingChildren = ( element ).querySelectorAll( selector );

                // Convert nodelist to array.
                return [ ...matchingChildren ];
            }
        );

        // Flatten the array
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce?v=a
        const flattened = arrayOfNodes.reduce( ( a, b ) => [ ...a, ...b ]);
        return flattened;
    }

    /**
     * Offers safe way to stop a JS event.
     *
     * Example usage:
     * Theme.Common.stop(e);
     *
     * @param e Event object.
     */
    static stop( e ) {
        e.preventDefault ? e.preventDefault() : ( e.returnValue = false );
    }

    /**
     * Select a list of matching elements, context is optional.
     *
     * @param  {string} selector The query selector string.
     * @param  {object} context  A query context object.
     * @return {object}          Returns empty nodelist if no matches are found; otherwise, it returns a nodelist of matching elements.
     */
    static $( selector, context ) {
        return ( context || document ).querySelectorAll( selector );
    }

    /**
     * Select the first match only, context is optional.
     *
     * @param  {string} selector The query selector string.
     * @param  {object} context  A query context object.
     * @return {object|null}     Returns null if no matches are found; otherwise, it returns the first matching element.
     */
    static $1( selector, context ) {
        return ( context || document ).querySelector( selector );
    }

     /**
     * Search autocomplete.
     * Uses jQuery-ui autocomplete for the autocomplete.
     */
    searchAutocomplete() {

        /**
         * Set local data to search array results.
         * note: LocalData is passed to javascript with wp-localize-script in setup.php.
         */
        const searchArray = $.parseJSON( LocalData.search_results );

        // Set element to variable to use it inside autocomplete.
        /* var searchForm = this.searchFormDesktop; */

        // Init jQuery autocomplete.
        this.searchFormInput.autocomplete({
            source: searchArray,
            delay: 0,
            minLength: 3,
            select: ( e, ui ) => {
            this.searchFormInput.val( ui.item.label );
                this.searchFormDesktop.submit();
            }
        }).data( 'ui-autocomplete' )._renderItem = function( ul, data ) {
            let item = $( '<li class="ui-menu-item ui-menu-item-wrapper">' );

                item.append( data.label );

                if ( data.corporate ) {
                    item.append( '<span class="result-list__post-corporate">Yritys</span>' );
                }

                item.appendTo( ul );

                return item;
        };
    };

    /**
     * Add current year to first footer socket
     *
     */
    addFooterDate() {
        let firstFooterSocket = $( '.footer__socket-text' ).first();
        let year = new Date();

        firstFooterSocket.append( year.getFullYear() );
    }

    /**
     * Hande WebFontLoader.
     */
    webFontLoader() {
        WebFont.load({
            typekit: {
                id: TypekitData.id
            }
        });
    }
}

// Export the class reference.
module.exports = Common;



// WEBPACK FOOTER //
// ./assets/scripts/common.js